import * as generator from "generate-password-browser";

export function isObject(value) {
  return typeof value === 'object' && !Array.isArray(value) && value !== null
}
export function isBoolean(value) {
  return typeof value === 'boolean'
}
export function isNumber(value) {
  return typeof value === 'number' && !isNaN(value)
}
export function isArray(value) {
  return Array.isArray(value)
}
export function isEmpty(value) {
  if (value === null || value === undefined) return true
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0
  if (value instanceof Map || value instanceof Set) return value.size === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}


export function getPrepareData(data = {}, keys = [], removeEmpty = true) {
  const res = JSON.parse(JSON.stringify(data))
  keys.forEach(key => {
    if (res[key] && isObject(res[key])) {
      res[key] = res[key].uuid
    }
    if (res[key] && Array.isArray(res[key])) {
      res[key] = res[key].map(m => m.uuid)
    }
    if (!res[key] && removeEmpty) delete res[key]
  })
  return res
}

export function omitEmptyDeepFilters(obj = {}) {
  return Object.entries(obj).reduce((cur, [key, value]) => {
    if (isObject(value)) {
      cur[key] = omitEmptyDeepFilters(value)
      if (isEmpty(cur[key])) {
        delete cur[key]
      }
    } else {
      if (['operator', 'value'].includes(key) && obj.operator && !obj.value) {
        // ignoring operator and value keys if value is empty
      } else {
        if (
          !(!isBoolean(value) && !isNumber(value) && !value) ||
          (isArray(value) && isEmpty(value))
        ) {
          cur[key] = value
        }
      }
    }
    return cur
  }, {})
}

export function generatePassword(length = 30) {
  return generator.generate({
    length,
    numbers: true,
    uppercase: true,
    lowercase: true,
    symbols: '#?!@$%^&*-',
    strict: true,
  })
}
export function generateTemporaryId(){
  return 'temp_' + generatePassword(16)
}

export function prepareDataForServer(items, removeTempId = true) {
  const newItems = items.filter(item => item._status === 'new').map(item => {
    // eslint-disable-next-line no-unused-vars
    const { _status,...rest } = item;
    if(removeTempId) delete rest.id
    return rest;
  });
  const updatedItems = items.filter(item => item._status === 'updated').map(item => {
    // eslint-disable-next-line no-unused-vars
    const { _status, ...rest } = item;
    return rest; // remove status
  });
  const deletedItems = items.filter(item => item._status === 'deleted').map(item => item.uuid); // only id for remove
  const otherItems = items.filter(item => !('_status' in item)); // other items to save children
  return { newItems, updatedItems, deletedItems, otherItems };
}

export function debounce(func, timeout = 300){
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}